import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client/react/hooks';

import query, { ContestQuery } from './contest.graphql';
import defaultStyles from './contest.scss';
import { FormattedMessage } from 'react-intl';

export interface Props {
    styles: typeof defaultStyles;
}

const Contest: React.FC<Props> = React.memo(props => {
    const { styles } = props;
    const { data } = useQuery<ContestQuery>(query);

    return data && data.contest ? (
        <>
            <div className={styles.promoWidget}>
                <a href={data.contest.url} className={styles.link}>
                    <h2 className={styles.promoHeading}>
                        <span>
                            <FormattedMessage id='CONTEST' /> s
                        </span>
                        <img className={styles.logo} src={(data.contest.logo && data.contest.logo.src) || ''} />
                    </h2>
                </a>
                <ul className={styles.list}>
                    <li className={styles.forumWidgetItem}>
                        <a
                            href={data.contest.url}
                            className={styles.link}
                        >
                            {data.contest.title}
                        </a>
                    </li>
                </ul>
            </div>
        </>
    ) : null;
});

export default Styled(defaultStyles)(Contest);
